import { useMemo } from 'react';
import { SearchSelectDirect } from '../searchSelect';
import { useGetAllWorkersQuery } from '../../redux/rental';
import { SelectItem } from '../../types/util/selectItem';

export const WorkerPicker = ({
  label = 'Velg ansatt',
  value = null,
  disabled = false,
  onChange = () => null,
}: {
  label?: string,
  value?: number | null,
  disabled?: boolean,
  onChange?: (v: number|undefined) => void,
}) => {
  const { data: workers } = useGetAllWorkersQuery();

  const options = useMemo((): SelectItem<number>[] => {
    if (!workers) return [];
    return workers.map((w): SelectItem<number> => ({
      id: w.employeeNumber,
      label: `${w.fullName ? w.fullName : 'Navn mangler'} - ${w.mobilePhoneWork ? w.mobilePhoneWork : 'Telefonnummer mangler'}`,
    }));
  }, [workers]);

  return (
    <SearchSelectDirect
      required
      disabled={disabled}
      errorLabel="Velg bestiller"
      label={label}
      value={value}
      onChange={onChange}
    >
      {options}
    </SearchSelectDirect>
  );
};
